import { render } from "./DividerSquadComponent.vue?vue&type=template&id=d5c30ae8&scoped=true"
import script from "./DividerSquadComponent.vue?vue&type=script&lang=js"
export * from "./DividerSquadComponent.vue?vue&type=script&lang=js"

import "./DividerSquadComponent.vue?vue&type=style&index=0&id=d5c30ae8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c30ae8"]])

export default __exports__